module.exports = __webpack_public_path__ + "static/media/nextJS.b9159e82.svg";